import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DeviceTypeCRUDInterface } from '../../component/filter/filter.class';
import * as _ from 'lodash';
import { ActiveStatuses, StatusesEnum } from '../../../../constants';
import { FilterConditionInterface } from '../../../store/filter/filter.model';
import { DeviceTypeCRUDResponseInterface, FilterServiceInterface } from './service.class';

@Injectable({
  providedIn: 'root',
})
export class DeviceTypeService implements FilterServiceInterface {
  constructor(public http: HttpClient, @Inject('API_BASE_URL') private baseUrl: string) {}

  private readonly routes: string = 'device-type';

  getDeviceTypes(
    page: number,
    limit: number,
    lineIds: string[],
    filterParams: FilterConditionInterface[],
  ): Promise<DeviceTypeCRUDInterface[]> {
    const queryParams: {
      $and: object[];
    } = {
      $and: [],
    };
    let params: HttpParams = new HttpParams();
    const searchObject: object = {};
    const orObject: { $or: object[] } = { $or: [] };

    _.set(searchObject, 'status.$eq', StatusesEnum.ACTIVE);

    filterParams.forEach((filterParam: FilterConditionInterface) => {
      if (filterParam.prop === 'currentLine' || !filterParam.query) {
        return;
      }

      orObject.$or.push({ [filterParam.prop]: { [filterParam.condition]: filterParam.query } });
    });

    queryParams.$and.push(searchObject, orObject);

    params = params.set('page', String(page));
    params = params.set('limit', String(limit));
    params = params.set('s', JSON.stringify(queryParams));

    return this.getData(params);
  }

  public getData(params?: HttpParams): Promise<DeviceTypeCRUDInterface[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${this.baseUrl}/${this.routes}`, { params })
        .subscribe((response: DeviceTypeCRUDResponseInterface) => {
          if (response.hasOwnProperty('data')) {
            resolve(response.data);
          } else {
            reject();
          }
        });
    });
  }
}
